"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utilities_1 = require("@uifabric/utilities");
exports.SELECTION_CHANGE = utilities_1.SELECTION_CHANGE;
exports.SelectionDirection = utilities_1.SelectionDirection;
exports.SelectionMode = utilities_1.SelectionMode;
//# sourceMappingURL=interfaces.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/utilities/selection/interfaces.js
// module id = 867
// module chunks = 0